function isMobileSlideshow() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function initSlideshowCursorNav(component) {
  if (!component || component.dataset.seyCursorNav === 'true') return;

  const cursor = component.querySelector('.slideshow__cursor');
  const prevButton = component.querySelector('button[name="previous"]');
  const nextButton = component.querySelector('button[name="next"]');

  if (!cursor || !prevButton || !nextButton) return;

  component.dataset.seyCursorNav = 'true';

  let direction = 'next';

  const isExempt = (target) =>
    Boolean(target.closest('a, .slideshow__text, .slideshow__controls, .slideshow__autoplay'));

  const hideCursor = () => {
    cursor.classList.remove('is-visible');
    component.classList.remove('is-cursor-nav');
  };

  const onMove = (event) => {
    if (isMobileSlideshow()) {
      hideCursor();
      return;
    }

    const rect = component.getBoundingClientRect();
    cursor.style.transform = `translate(${event.clientX - rect.left}px, ${event.clientY - rect.top}px) translate(-50%, -50%)`;

    if (isExempt(event.target)) {
      hideCursor();
      return;
    }

    direction = event.clientX - rect.left < rect.width / 2 ? 'prev' : 'next';
    cursor.classList.add('is-visible');
    cursor.classList.toggle('is-prev', direction === 'prev');
    cursor.classList.toggle('is-next', direction === 'next');
    component.classList.add('is-cursor-nav');
  };

  const onClick = (event) => {
    if (isMobileSlideshow() || isExempt(event.target)) return;
    event.preventDefault();
    (direction === 'prev' ? prevButton : nextButton).click();
  };

  component.addEventListener('mousemove', onMove);
  component.addEventListener('mouseleave', hideCursor);
  component.addEventListener('click', onClick);
}

function initSlideshowAutoplay(component) {
  if (!component || component.dataset.seyAutoplay === 'true') return;

  const slider = component.querySelector('[id^="Slider-"]');
  const nextButton = component.querySelector('button[name="next"]');
  if (!slider || !nextButton || slider.getAttribute('data-autoplay') !== 'true') return;

  component.dataset.seyAutoplay = 'true';
  component.autoplayButtonIsSetToPlay = true;

  if (typeof component.pause === 'function') {
    component.pause();
  }

  const advance = () => {
    if (slider.getAttribute('data-autoplay') !== 'true') return;
    nextButton.click();
  };

  component.querySelector('.slideshow__controls--progress')?.addEventListener('animationend', (event) => {
    if (event.animationName !== 'sey-slideshow-progress') return;
    if (!event.target.classList.contains('slideshow__progress-fill')) return;
    if (!event.target.closest('.slider-counter__link--active')) return;
    advance();
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const speed = Number(slider.dataset.speed || 5) * 1000;
    component._seyAutoplay = window.setInterval(advance, speed);
  }
}

function bindSlideshows(root = document) {
  root.querySelectorAll('slideshow-component.slider-mobile-gutter').forEach((component) => {
    initSlideshowCursorNav(component);
    initSlideshowAutoplay(component);
  });
}

bindSlideshows();
document.addEventListener('shopify:section:load', (event) => bindSlideshows(event.target));
